import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { StorageModuleStateDate } from 'src/types/masters';

// Load from localStorage if available

const initialState: StorageModuleStateDate = {
  searchBy: '',
  projectFilterId: ''
};

const slice = createSlice({
  name: 'storageModule',
  initialState,
  reducers: {
    setSearchStorage(state, action: PayloadAction<string>) {
      state.searchBy = action.payload;

      // Save to localStorage
    },
    setProjectId(state, action: PayloadAction<string>) {
      state.projectFilterId = action.payload;

      // Save to localStorage
    },
    clearStorage(state) {
      state.searchBy = '';
      state.projectFilterId = '';
    }
  }
});

export const { setSearchStorage, setProjectId, clearStorage } = slice.actions;
export const reducer = slice.reducer;
